import {NOTIFICATION_TYPES} from "../../helpers/notify"

export default [
  // Fields
  {
    key: "create-field-denied",
    message: "Acesso negado para criação de área. Você não possui permissões para criar áreas neste processamento.",
    notify: true,
  },
  {
    key: "update-field-denied",
    message: "Acesso negado para edição de área. Você não possui permissões para editar áreas neste processamento.",
    notify: true,
  },
  {
    key: "delete-field-denied",
    message: "Acesso negado para remoção de área. Você não possui permissões para remover áreas neste processamento.",
    notify: true,
  },
  {
    key: "invalid-crs",
    message: "O sistema de coordenadas do arquivo enviado é inválido.",
    notify: true,
  },
  {
    key: "import-field-shp-invalid-geometry",
    message: "Geometria não suportada. O shapefile enviado deve conter apenas geometrias dos tipos Polygon ou Multipolygon.",
    notify: true,
  },
  {
    key: "import-field-geojson-invalid-geometry",
    message: "Geometria não suportada. O geojson enviado deve conter apenas geometrias dos tipos Polygon ou Multipolygon.",
    notify: true,
  },
  {
    key: "import-field-kml-invalid-geometry",
    message: "Geometria não suportada. O kml enviado deve conter apenas geometrias dos tipos Polygon ou Multipolygon.",
    notify: true,
  },
  {
    key: "import-field-kml-bad-format",
    message: "O arquivo KML enviado está mal formatado ou em algum formato não suportado.",
    notify: true,
  },
  {
    key: "import-field-shp-files-missing",
    message: "O arquivo comprimido enviado não contém os arquivos '.shp' e '.shx'.",
    notify: true,
  },
  // Processings
  {
    key: "generate-processing-share-inside-project-denied",
    message: "Não é possível compartilhar processamentos dentro de um projeto. Para isso compartilhe o projeto.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "generate-processing-share-denied",
    message: "Para compartilhar processamentos você precisa ser o dono do mesmo.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-share-link-not-found",
    message: "Não foi encontrado dados para este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-share-link-denied",
    message: "Seu usuário não está na lista de e-mails permitidos para usar este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-share-link-already-used",
    message: "Este link de compartilhamento já foi utilizado pelo seu usuário.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-share-link-expired",
    message: "Este link de compartilhamento já expirou.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "generate-processing-clone-bad-status",
    message: "Só é possível compartilhar processamentos com status de finalizado.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "generate-processing-clone-inside-project-denied",
    message: "Não é possível compartilhar processamentos dentro de um projeto. Para isso compartilhe o projeto.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "generate-processing-clone-denied",
    message: "Para compartilhar processamentos você precisa ser o dono do mesmo.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-clone-link-not-found",
    message: "Não foi encontrado dados para este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-clone-link-denied",
    message: "Seu usuário não está na lista de e-mails permitidos para usar este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-clone-link-already-used",
    message: "Este link de compartilhamento já foi utilizado pelo seu usuário.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "processing-clone-link-expired",
    message: "Este link de compartilhamento já expirou.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "start-processing-bad-status",
    message: "Esse processamento já está processando ou já foi finalizado.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "start-processing-too-few-images",
    message: "O minimo de imagens para começar um processamento é 8",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "start-processing-missing-template",
    message: "Não é possível iniciar o processamento sem selecionar o Template de processamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "create-processing-inside-project-denied",
    message: "Seu usuário não possui as permissões necessárias para criar um processamento dentro do projeto selecionado.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "subscription-disallowed-tilling",
    message: "Seu plano atual não permite criar processamentos de ortomosaico.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "subscription-disallowed-processing-active",
    message: "Você chegou no limite máximo de criação de processamentos ativos permitidos pelo seu plano.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "subscription-disallowed-processing-created",
    message: "Você chegou no limite máximo de criação de processamentos do seu plano.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "subscription-disallowed-storage-full",
    message: "Você chegou no limite máximo de armazenamento de processamentos do seu plano.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "subscription-disallowed-start-processing-with-gcp",
    message: "Seu plano não permite processamentos com Pontos de Controle.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "subscription-disallowed-gcp",
    message: "Seu plano não permite a criação de processamentos com GCP.",
    notify: false,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "update-processing-denied",
    message: "Você não tem permissão para editar este processamento",
    notify: false,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "delete-processing-denied",
    message: "Você não tem permissão para remover este processamento",
    notify: false,
    type: NOTIFICATION_TYPES.WARNING,
  },
  // Projects
  {
    key: "generate-project-share-denied",
    message: "Para compartilhar a pasta você precisa ser o dono da mesma.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-share-link-not-found",
    message: "Não foi encontrado dados para este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-share-link-denied",
    message: "Seu usuário não está na lista de e-mails permitidos para usar este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-share-link-already-used",
    message: "Este link de compartilhamento já foi utilizado pelo seu usuário.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-share-link-expired",
    message: "Este link de compartilhamento já expirou.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "generate-project-clone-denied",
    message: "Para compartilhar projetos você precisa ser o dono do mesmo.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-clone-link-not-found",
    message: "Não foi encontrado dados para este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-clone-link-denied",
    message: "Seu usuário não está na lista de e-mails permitidos para usar este link de compartilhamento.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-clone-link-already-used",
    message: "Este link de compartilhamento já foi utilizado pelo seu usuário.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "project-clone-link-expired",
    message: "Este link de compartilhamento já expirou.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "update-project-denied",
    message: "Você não tem permissões para editar este projeto.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
  {
    key: "delete-project-denied",
    message: "Você não tem permissões para remover este projeto.",
    notify: true,
    type: NOTIFICATION_TYPES.WARNING,
  },
]
